import React from "react";
// import classnames from "classnames";
import {
  NewInputText,
  // TextAreaReusableComponent,
} from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../../../store/validation/is-Empty";
import Switch from "react-switch";

export const HealthAndSenitationProtocol = ({
  protocolCheck,
  protocolCheckHandler,
  onChange,
  discriptionProtocol,
  onBackButtonClick,
  errors,
  onFocusOut,
  name,
  onClick,
  buttonType,
  displayNextButton,
}) => {
  return (
    <React.Fragment>
      <div className="col-12">
        <div className="row health_and_senitation_onboarding_main_div">
          <div className="col-9 col-sm-9 col-md-10 col-lg-10 col-xl-10 pl-0 health_and_senitation_onboarding_main_divone">
            <h5>
              Do you have facility maintained as per Health and Hygiene
              standards and any COVID-19 protocol?
            </h5>
            <p>Turn off this section if doesn’t applicable to your Business</p>
          </div>
          <div className="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2 p-0 health_and_senitation_onboarding_main_divtwo">
            <Switch
              checked={protocolCheck}
              onChange={protocolCheckHandler}
              offColor="#EEEEEE"
              onColor="#EEEEEE"
              offHandleColor="#212121"
              onHandleColor="#59F832"
              handleDiameter={22}
              uncheckedIcon={false}
              checkedIcon={false}
              height={14}
              width={38}
              boxShadow="-2px 0px 5px #0000003B"
              activeBoxShadow="-2px 0px 5px #0000003B"
              id="material-switch"
            />
          </div>
        </div>
      </div>
      {protocolCheck === true ? (
        <div className="col-12 p-0 located-inside-margin-mobile">
          <NewInputText
            rows="8"
            onChange={onChange}
            onFocusOut={onFocusOut}
            name={name}
            value={discriptionProtocol}
            multiline={true}
            labelText="Information for users"
            controlClass={"outlined-helperText"}
          />
          {/* <TextAreaReusableComponent
          controlId="discriptionProtocol"
          displayText={false}
          placeholder="eg. A bright Atmosphere*"
          rows="8"
          onChange={onChange}
          onFocusOut={onFocusOut}
          name={name}
          value={discriptionProtocol}
          inputClassName={classnames("input-text-area text-area-new", {
            invalid: errors,
          })}
          error={errors}
        /> */}
        </div>
      ) : null}
      <div className="onboarding-map-setup-screen-autodetect-button">
        {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
        <ReusableOnboardingButton
          buttonTitle="Back Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          buttonText="Back"
          buttonType="button"
          onClick={onBackButtonClick}
        />
        <ReusableOnboardingButton
          buttonTitle="Next Button"
          buttonClass={
            protocolCheck && isEmpty(discriptionProtocol)
              ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
              : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
          }
          disabled={
            protocolCheck && isEmpty(discriptionProtocol) ? true : false
          }
          buttonText={displayNextButton === true ? "Save & Next" : "Next"}
          onClick={onClick}
          buttonType={buttonType}
        />
        {/* </div> */}
      </div>
    </React.Fragment>
  );
};
